@charset "UTF-8";

/* src/app/modules/print-cards/components/print-labels/label-content/custom-labels-2x4/sku-inventory-label-stack-content/sku-inventory-label-stack-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.sku-label {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
}
.top-side {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.375rem;
  gap: 0.5rem;
}
.top-side .left-side {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.top-side .right-side {
  text-align: end;
  flex: 1;
}
.classification-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
  height: 2.5rem;
  width: 2.5rem;
  line-height: 1;
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.25rem;
}
.product-image {
  height: 3.125rem;
  width: 3.125rem;
  object-fit: contain;
}
.product-size {
  font-family: poppins, sans-serif;
  font-style: italic;
  font-weight: 700;
  overflow: clip;
  overflow-clip-margin: 0.1rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  font-size: 1.5rem;
  text-align: right;
  line-height: 100%;
}
.product-name {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-size: 1.875rem;
  overflow: visible;
  line-height: 110%;
}
.product-sku {
  font-family: poppins, sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 1.125rem;
}
.product-brand {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-size: 1.375rem;
  overflow: visible;
}
/*# sourceMappingURL=sku-inventory-label-stack-content.component.css.map */
